import React from 'react';

import Footer from '../../common/components/layout/Footer';
import Topbar from '../../common/components/layout/Topbar';
import Sidenav from '../../common/components/layout/Sidenav';

function VerticalLayout({ children }) {
  return (
    <>
      <Sidenav />
      <Topbar />
      <div className="content-page">
        {children}
        <Footer />
      </div>
    </>
  );
}

export default VerticalLayout;
